( () => {
	const allSkipButtons = document.querySelectorAll<HTMLButtonElement>( 'button[data-role="skip-to-content-button"]' );

	allSkipButtons.forEach( ( skipButton ) => {
		const jumpContentElement = document.querySelector<HTMLElement>( skipButton.dataset.skipTo ?? 'main#main-content' );
		if ( ! jumpContentElement ) {
			skipButton?.remove();
			return;
		}

		if ( ! jumpContentElement.id ) {
			jumpContentElement.id = crypto.randomUUID();
		}

		if ( ! skipButton && ! jumpContentElement ) return;

		skipButton?.addEventListener( 'click', () => {
			const originalLocation = window.location.href;
			window.location.hash = jumpContentElement?.id;

			window.history.replaceState( null, '', originalLocation );
		} );
	} );
} )();
